module.exports = __webpack_public_path__ + "img/65276b4a02788928cdbb69ee1f04927d.65276b4a.png";